import type { FC } from 'react';

// Full-bleed scene illustration. Decorative (aria-hidden) — all meaningful
// content is in the text above. Source path is per-industry, supplied by
// the parent page from config.
export const OnePagerIllustration: FC<{ src: string }> = ({ src }) => (
  <div className="block w-full leading-[0]" aria-hidden="true">
    <img src={src} alt="" className="block h-auto w-full" />
  </div>
);
